import React, { FunctionComponent } from "react";
import Link from "next/link";

import removeMarkdown from "src/lib/removeMarkdown";

import ForkIcon from "../../icons/ForkIcon";
import ProjectAvatar from "../ProjectAvatar";
import { ProfileProjectSummary } from "./ProfileData";
import VisibilityIndicator from "../VisibilityIndicator";
import DependentsIcon from "../../icons/DependentsIcon";
import StarBadge from "../StarBadge";

type ProfileProjectCardProps = {
  project: ProfileProjectSummary;
};

const ProfileProjectCard: FunctionComponent<ProfileProjectCardProps> = ({
  project,
}) => {
  return (
    <Link href={`/${project.pathWithNamespace}`} prefetch={false}>
      <a className="profile-project-link">
        <div className={`profile-project-card ${project.type.toLowerCase()}`}>
          <VisibilityIndicator fontSize={12} visibility={project.visibility} />
          {project.type === "Simulation" && project.avatar && (
            <ProjectAvatar project={project} size={"148px"} />
          )}
          <div className="details">
            <div className="project-shortname">
              {project.name !== "Simulation" && project.pathWithNamespace}
            </div>
            <div className="project-info">
              <div className="project-type">{project.type}</div>
              {!!project.forkCount && (
                <div className="fork-count">
                  <ForkIcon />
                  {project.forkCount}
                </div>
              )}
              {!!project.dependents && (
                <div className="dependents-count">
                  <DependentsIcon />
                  {project.dependents}
                </div>
              )}
              {!!project.starCount && <StarBadge project={project} />}
            </div>
            <div className="project-title">{project.name}</div>
            <div className="project-desc small-text two-lines-max">
              {removeMarkdown(project.description)}
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default ProfileProjectCard;
